import React from "react";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import {
  URL,
  getAuthorizationHeader,
  idEmpresa
} from "../../constans/constants";
import axios from "axios";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { logout } from "../login/SesionService"
import { registrarUnidad, editarUnidad } from "./OrganizacionService";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import { validateForm } from "../../constans/validationUtils";
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
  integrarConHandleInput
} from '../../constans/form-error-utils';

class Unidad extends React.Component {
  constructor(props) {
    super(props);

    const originalHandleInput = this.handleInput;

    this.handleInput = integrarConHandleInput(this, originalHandleInput);


    this.state = {
      id: "",
      descripcion: "",
      unidadPadreID: "",
      unidadPadreDescripcion: "",
      correoNotificacion: "",
      miembros: [],
      unidades: [],
      empresa: "",
      isEditarUnidad: false,
      errors: {
        descripcion: null,
        correoNotificacion: null,
        unidadPadreID: null,
        showErrors: false
      }
    };
    this.dialogRef = React.createRef();
  }

  reglasValidacionCampos = {

    descripcion: [
      { required: true, message: 'Campo obligatorio' },
    ],
    correoNotificacion: [
      { required: true, message: 'Campo obligatorio' },
      { customValidator: (value, formData) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value), message: "Ingrese una dirección de email válida" }
    ],
    unidadPadreID: [
      { required: true, message: 'Debe seleccionar una unidad padre para la que vas a crear' },

    ]
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        const primeraUnidad = this.state.unidades.length > 0 ? this.state.unidades[0].id : "";
        this.setState({
          descripcion: "",
          correoNotificacion: "",
          unidadPadreID: primeraUnidad,
          errors: { descripcion: null, correoNotificacion: null, unidadPadreID: null, showErrors: false }
        });
        this.abrirModal();
      } else {
        this.cerrarModalConAnimacion();
      }
    }
  }

  abrirModal = () => {
    if (this.dialogRef.current && !this.dialogRef.current.open) {
      this.dialogRef.current.showModal();
    }
  }

  cerrarModal = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.close();
    }
  }

  cerrarModalConAnimacion = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      // Quitar la clase [open] para activar la animación de cierre
      this.dialogRef.current.style.scale = '0';

      // Esperar a que termine la animación antes de cerrar realmente
      setTimeout(() => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
          this.dialogRef.current.close();
        }
      }, 300); // 300ms coincide con la duración de tu animación CSS
    }
  }

  manejarCancelar = () => {
    // Activar animación de cierre antes de llamar al callback del padre
    this.cerrarModalConAnimacion();

    // Esperar a que termine la animación antes de actualizar el estado del padre
    setTimeout(() => {
      this.props.cerrarModal();
    }, 300);
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  componentDidMount() {
    configurarLimpiezaAutomatica()
    const datosUnidad = this.props.location?.state;
    if (datosUnidad) {
      const datosUnidad = this.props.location?.state || {};
      this.setState({
        isEditarUnidad: true,
        id: datosUnidad.id || '',
        descripcion: datosUnidad.descripcion || '',
        unidadPadreID: datosUnidad.unidadPadre,
        unidadPadreDescripcion: datosUnidad.unidadPadreDescripcion || '',
        miembros: datosUnidad.miembros || '',
        empresa: datosUnidad.empresa || '',
        correoNotificacion: datosUnidad.correoNotificacion || '',
      })
    }

    const cookies = new Cookies();
    const empresaId = cookies.get('empresa');
    axios
      .get(
        URL + `organizacion/unidades?idEmpresa=${empresaId}`,
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          const unidades = res.data.datos || [];
          const unidadPadreID = !this.state.unidadPadreID && unidades.length > 0
            ? unidades[0].id
            : this.state.unidadPadreID;
          this.setState({ unidades, unidadPadreID });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
    if (this.props.edit) {
      this.setState({
        id: this.props.unidad.id, unidadPadreID: this.props.unidad.unidadPadreID,
        descripcion: this.props.unidad.descripcion,
        correoNotificacion: this.props.unidad.correoNotificacion
      })
    }

    if (this.props.isOpen) {
      this.abrirModal();
    }

  }

  handleAgregarMiembro = () => {
    this.props.history.push({
      pathname: '/estructura/organizacion/agregar-miembro',
      state: {
        unidadID: this.state.id,
        miembros: this.state.miembros
      }
    })
  }

  handleInput = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    this.setState({
      [name]: val,
    });
  };

  editar = event => {
    event.preventDefault();
    let json = {
      descripcion: this.state.descripcion,
      unidadPadre: this.state.unidadPadreID,
      correoNotificacion: this.state.correoNotificacion,
      id: this.state.id
    }
    editarUnidad(json, idEmpresa())
      .then((respuesta) => {
        this.props.history.push({
          pathname: '/estructura/organizacion',
          state: {
            mostrarMensajeFlash: true,
            mensajeFlash: respuesta.mensaje,
            mensajeFlashSeverity: !respuesta.error ? "exito" : "error",
          }
        })
      })
  }

  guardarUnidad = event => {
    event.preventDefault();
    let json = {}
    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (isValid) {
      mostrarErroresEnFormulario({})
      if (!this.props.edit) {
        json = {
          descripcion: this.state.descripcion,
          unidadPadre: this.state.unidadPadreID,
          correoNotificacion: this.state.correoNotificacion
        }
        registrarUnidad(json, idEmpresa())
          .then((respuesta) => {
            this.manejarCancelar();
            this.props.onResultado(respuesta);
          })
      } else {
        editarUnidad(json, idEmpresa())
          .then((respuesta) => {
            this.cerrarModalConAnimacion();
            this.props.onResultado(respuesta);

          })
      }
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }

  }

  renderNuevaUnidad = () => {
    return (
      <div className="component-modal">

        <dialog ref={this.dialogRef} className="modal" id="modal-nueva-unidad">
          <div className="modal-content">

            <div className="modal-head">
              <h3 className="modal-title"> Agregar Unidad </h3>
              <p className="modal-caption"> Crea nuevas unidades principales o agrégalas a otros niveles  </p>
            </div>

            <div className="modal-body">
              <form onSubmit={this.guardarUnidad} className="form">
                <div className="form-group">
                  <input type="text" id="descripcion" name="descripcion" className="form-input" value={this.state.descripcion} onChange={this.handleInput} />
                  <label htmlFor="descripcion" className="form-label"> Descripción </label>
                </div>
                <div className="form-group">
                  <input type="email" name="correoNotificacion" id="correoNotificacion" className="form-input" value={this.state.correoNotificacion} onChange={this.handleInput} />
                  <label htmlFor="correoNotificacion" className="form-label"> Correo Electrónico </label>
                </div>
                <div className="form-group">
                  <select className="form-select" name="unidadPadreID" id="unidadPadreID" onChange={this.handleInput} value={this.state.unidadPadreID}>

                    {this.state.unidades != null
                      ?
                      this.state.unidades.map((elemento) => (
                        <option key={elemento.id} value={elemento.id}>
                          {elemento.descripcion}
                        </option>
                      ))
                      :
                      <option key="" value="" selected></option>
                    }
                  </select>
                  <label htmlFor="unidadPadreID" className="form-label"> Unidad padre </label>
                </div>

                <div className="modal-footer">
                  <button className="btn-medium btn-base-outline" id="close-modal" type="reset" onClick={this.manejarCancelar}> Cancelar </button>
                  <button className="btn-medium btn-primary" type="submit"> Agregar </button>
                </div>
              </form>
            </div>

          </div>
        </dialog>

      </div>
    );
  }

  renderEditarUnidad = () => {
    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={'/bandeja/pendientes'}
              breadcrumbs={
                [
                  { label: 'Organigrama', path: '' },
                  { label: 'Editar Unidad', path: '' }
                ]
              }
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title"> Unidad {this.props.location?.state.descripcion} </h1>
                <p className="page-description"> Puedes editar detalles de la unidad y ver miembros </p>
              </div>
              <div className="head-actions">
                <button className="btn-medium btn-primary open-dialog" data-dialog="modal-nueva-unidad" onClick={() => this.handleAgregarMiembro(true)}
                ><span className="material-symbols-outlined">lan</span>Agregar miembro</button>
              </div>
            </div>
          </div>
        </header>
        <div className="wrapperContent">
          <div className="page-container">

            <div className="card mb-2">
              <form onSubmit={this.editar} className="form">
                <h3 className="form-subtitle"> Detalles de la unidad </h3>
                <div className="form-group__inline x3">
                  <div className="form-group">
                    <input type="text" id="descripcion" name="descripcion" className="form-input" value={this.state.descripcion} onChange={this.handleInput} />
                    <label htmlFor="descripcion" className="form-label"> Descripción </label>
                  </div>
                  <div className="form-group">
                    <select className="form-select" name="unidadPadreID" id="unidadPadreID" onChange={this.handleInput} value={this.state.unidadPadreID}>
                      <option key="" value="" selected></option>
                      {this.state.unidades.map((elemento) => (
                        <option key={elemento.id} value={elemento.id}>
                          {elemento.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <input type="email" name="correoNotificacion" id="correoNotificacion" className="form-input" value={this.state.correoNotificacion} onChange={this.handleInput} />
                    <label htmlFor="correoNotificacion" className="form-label">  Dirección de e-mail para notificaciones  </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn-medium btn-primary" type="submit"> Guardar cambios </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.props.isOpen)
      return this.renderNuevaUnidad();
    else {
      return this.state.isEditarUnidad ? this.renderEditarUnidad() : null;
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
});

export default connect(null, mapDispatchToProps)(Unidad);
